/*
 * @file: page exposure hook
 * @author: xuyong08
 */
import {useEffect, useRef} from 'react';
import Exposure from '@utils/ubcLogger/exposure';
export default function usePageExposure(options = {}, timeout = 100) {
    const trackerRef = useRef<Exposure>();
    useEffect(
        () => {
            const timer = setTimeout(
                () => {
                    trackerRef.current = new Exposure(options);
                },
                timeout
            );
            return () => {
                trackerRef.current?.removeObserve();
                clearTimeout(timer);
            };
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
}
